import {
  Box,
  CongestionMarker,
  GridItem,
  Heading,
  PageGrid,
  Stack,
  Text,
} from '@ads-core/components';
import { CongestionFeedbackProps } from '../CongestionFeedback';
import { CongestionButton } from './_CongestionButton';
import { CONGESTION_DIRECTION_CONSUME, CONGESTION_DIRECTION_SUPPLY } from './constant';

type CongestionDetailsProps = {
  consume: boolean;
  supply: boolean;
  congestions: boolean;
  congestionText: string;
  feedback: CongestionFeedbackProps;
  handlePrimaryButton: (value: string) => void;
  handleSecondaryButton: (value: string) => void;
};

export const CongestionFeedback = ({
  consume,
  supply,
  feedback,
  congestionText,
  congestions,
  handlePrimaryButton,
  handleSecondaryButton,
}: CongestionDetailsProps) => {
  return (
    <PageGrid>
      <GridItem columnStart={{ initial: '1', lg: '3' }} columnEnd={{ initial: '-1', lg: '-3' }}>
        <Box paddingBottom={16} asChild>
          <Stack gap={6}>
            {consume !== undefined || supply !== undefined ? (
              <Stack direction="row" alignY="center" gap={6}>
                <CongestionMarker titel={CONGESTION_DIRECTION_CONSUME} congestion={consume} />
                <CongestionMarker titel={CONGESTION_DIRECTION_SUPPLY} congestion={supply} />
              </Stack>
            ) : null}

            <Heading size="h3" as="h2">
              {feedback.description}
            </Heading>

            {congestionText && congestions ? <Text>{congestionText}</Text> : null}

            {feedback.buttonPrimary || feedback.buttonSecondary ? (
              <Stack direction={{ initial: 'column', sm: 'row' }} gap={6}>
                {feedback.buttonPrimary ? (
                  <CongestionButton
                    {...feedback.buttonPrimary}
                    variant="primary"
                    handleOnClick={handlePrimaryButton}
                  />
                ) : null}

                {feedback.buttonSecondary ? (
                  <CongestionButton
                    {...feedback.buttonSecondary}
                    variant="ghost"
                    handleOnClick={handleSecondaryButton}
                  />
                ) : null}
              </Stack>
            ) : null}
          </Stack>
        </Box>
      </GridItem>
    </PageGrid>
  );
};
